export default __webpack_public_path__ + "static/media/015-fire-truck.9f422b5f.png";